import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import { BodySmallMedium } from '@src/fonts/typography/Typography';

type TypeProps = 'success' | 'info' | 'warning' | 'danger';

type FeedbackMessageProps = {
  message: ReactNode;
  type: TypeProps;
};

const FeedbackMessage = ({ message, type }: FeedbackMessageProps) => {
  return <Container type={type}>{typeof message === 'string' ? <span>{message}</span> : message}</Container>;
};

export default FeedbackMessage;

const Container = styled.section<{ type: TypeProps }>`
  ${BodySmallMedium};
  display: flex;
  width: 100%;
  padding: 8px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  border-radius: 4px;

  ${({ type }) => {
    switch (type) {
      case 'success':
        return `background: ${LayoutColors.successLight}; color: ${LayoutColors.successDark}`;

      case 'danger':
        return `background: ${LayoutColors.errorLight}; color: ${LayoutColors.errorDark}`;

      case 'warning':
        return `background: ${LayoutColors.warningLight}; color: ${LayoutColors.warningDark}`;

      default:
        return `background: ${LayoutColors.justBlueLigth}; color: ${LayoutColors.justBlue}`;
    }
  }}
`;
